import React from 'react';
import { RotateCcw, Shield, Smartphone, Youtube } from 'lucide-react';
import { useT } from '../services/i18n';

const TrustBadges = () => {
  const { t } = useT();
  const badges = [
    {
      icon: RotateCcw,
      title: t('home.trust.return'),
      description: t('home.trust.returnSub')
    },
    {
      icon: Shield,
      title: t('home.trust.payments'),
      description: ''
    },
    {
      icon: Smartphone,
      title: t('home.trust.app'),
      description: t('home.trust.appSub')
    },
    {
      icon: Youtube,
      title: t('home.trust.videos'),
      description: t('home.trust.videosSub')
    }
  ];

  return (
    <section className="py-8 bg-white border-y border-gray-100">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-6">
          {badges.map((badge, idx) => (
            <div
              key={idx}
              className="flex flex-col sm:flex-row items-center sm:items-center text-center sm:text-left gap-2 sm:gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer group"
            >
              <div className="w-11 h-11 sm:w-12 sm:h-12 flex-shrink-0 flex items-center justify-center rounded-full bg-gray-100 group-hover:bg-orange-50 transition-colors">
                <badge.icon size={22} className="text-gray-600 group-hover:text-orange-600 transition-colors" />
              </div>
              <div className="min-w-0">
                <p className="font-medium text-gray-900 text-xs sm:text-sm leading-snug">{badge.title}</p>
                {badge.description && (
                  <p className="text-[11px] sm:text-xs text-gray-500 leading-snug">{badge.description}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
